// API の識別用にランダムな文字列を作る
export function generateUniqueId(): string {
  return String(Math.floor(Math.random() * 100000))
}
